export default __webpack_public_path__ + "static/media/practice_makes_perfect.2b18f300.mp3";